import {
  IUiAccordionProps,
  UiAccordion,
  UiAccordionDetails,
  UiAccordionSummary,
} from "@smp/ui";
import { IconChevronDown } from "@tabler/icons-react";
import {
  forwardRef,
  PropsWithChildren,
  ReactNode,
  useCallback,
  useRef,
} from "react";

import classes from "./advisor_accordion.module.css";

export interface IAdvisorAccordionProps {
  title: ReactNode;
}

export const AdvisorAccordion = forwardRef<
  HTMLDivElement,
  PropsWithChildren<IAdvisorAccordionProps>
>(({ title, children }) => {
  const $summary = useRef<HTMLDivElement>();

  const handleChange = useCallback<NonNullable<IUiAccordionProps["onChange"]>>(
    (_event, expanded) => {
      if (expanded && $summary.current) {
        requestAnimationFrame(() => {
          $summary.current?.scrollIntoView({
            behavior: "smooth",
          });
        });
      }
    },
    [],
  );

  return (
    <UiAccordion
      className={classes.root}
      onChange={handleChange}
      TransitionProps={{ timeout: 0 }}
    >
      <UiAccordionSummary
        classes={{
          root: classes.summary,
          content: classes.summary__content,
        }}
        ref={$summary}
      >
        {title}
        <IconChevronDown className={classes.summary__icon} />
      </UiAccordionSummary>

      <UiAccordionDetails>{children}</UiAccordionDetails>
    </UiAccordion>
  );
});
